import { useFlow } from '@router/stackflow';
import { useAtom } from 'jotai';
import { RefObject, useEffect, useState } from 'react';

import { isCompleteVisibleAtom } from '../../../atoms/giftOrderAtoms';
import styles from '../styles.module.scss';

const REFLOW_DURATION_MS = 50;
const VISIBLE_ANIMATION_DURATION_MS = 350;
const CARD_ANIMATION_DURATION_MS = 1700;
const MOVE_DURATION_MS = 1000;

interface Props {
    ref: RefObject<HTMLDivElement|null>;
    cardRef: RefObject<HTMLImageElement|null>
}

function useCompleteAnimation({ ref, cardRef }:Props) {
  const [isVisible, setIsVisible] = useAtom(isCompleteVisibleAtom);
  const [message, setMessage] = useState<string>('구매한 카드로 선물을 전송중입니다.');
  const { replace } = useFlow();
  useEffect(() => {
    if (isVisible) {
      ref.current?.classList.remove(styles.none);
      const visibleTimeout = setTimeout(() => {
        ref.current?.classList.remove(styles.hide);
      }, REFLOW_DURATION_MS);
      const cardTimeout = setTimeout(() => {
        cardRef.current?.classList.add(styles.animate);
      }, VISIBLE_ANIMATION_DURATION_MS);
      const messageTimeout = setTimeout(() => {
        setMessage('구매하신 카드는 선불카드 페이지에서\n사용하실 수 있습니다.');
      }, VISIBLE_ANIMATION_DURATION_MS + CARD_ANIMATION_DURATION_MS);
      const moveTimeout = setTimeout(() => {
        // TODO router.replace('/gift/order/complete');
      }, VISIBLE_ANIMATION_DURATION_MS + CARD_ANIMATION_DURATION_MS + MOVE_DURATION_MS);
      return () => {
        clearTimeout(visibleTimeout);
        clearTimeout(cardTimeout);
        clearTimeout(messageTimeout);
        clearTimeout(moveTimeout);
        setIsVisible(false);
      };
    }
    return () => {};
  }, [cardRef, isVisible, ref, replace, setIsVisible]);
  return {
    message,
  };
}

export default useCompleteAnimation;
